import type { ImageSchema } from '../../../compatibility-overrides/editor-types';
import type { Question } from '../../../legacy-series-types';
import { questionLayoutToSlideLayout } from './question-layout-to-slide-layout';

export const questionToSlideImageReference = (
  question: Question,
): ImageSchema => {
  const [, layoutPosition, inset] = questionLayoutToSlideLayout(
    question.layout,
  );

  return {
    imageLayoutPosition: layoutPosition,
    imageInset: inset,
  };
};
